import React from 'react';
import PricingPageTableHeader from './PricingPageTableHeader';
import useStyles from './styles';

type Props = {
  isMobile?: boolean;
};

const IntroPricingPageTableHeader = ({
  isMobile = false,
}: Props) => {
  const classes = useStyles();

  const mobileSubtitle = isMobile
    ? (<div className={classes.subTitle}>(Swipe right to see columns)</div>)
    : null;

  return (
    <PricingPageTableHeader center>
      <div className={classes.title}>Our video production plans</div>
      { mobileSubtitle }
    </PricingPageTableHeader>
  );
};

export default IntroPricingPageTableHeader;
